import { useContext } from "react";
import {
  DocumentCreateContext,
  type DocumentCreateContextValue,
} from "@/pages/dokumente/documentCreateContextValue";

export function useDocumentCreate(): DocumentCreateContextValue {
  const ctx = useContext(DocumentCreateContext);
  if (!ctx) {
    throw new Error(
      "useDocumentCreate() muss innerhalb von <DocumentCreateProvider> verwendet werden.",
    );
  }
  return ctx;
}
